import { useQuery } from '@tanstack/react-query';
import { Select } from 'react-daisyui';
import { useNavigate } from 'react-router-dom';
import { queryOptionsGetWorkspacesPaginated } from '../../api/workspaces/workspaceApi';
import { SingleQueryResults } from '../../components/QueryResults/SingleQueryResults';

export const WorkspaceSelector = () => {
  const navigate = useNavigate();

  const workspacesQuery = useQuery(queryOptionsGetWorkspacesPaginated());

  return (
    <SingleQueryResults query={workspacesQuery}>
      {(workspaces) => (
        <>
          <h2 className="mb-4 text-xl font-medium">
            Select a workspace below to get started
          </h2>

          <Select
            className="w-[35rem] max-w-full"
            defaultValue="default"
            onChange={(ev) => navigate(`/workspace/${ev.target.value}/`)}
          >
            <option disabled value="default">
              Go to workspace
            </option>

            {workspaces.items.map((v) => (
              <option key={v._id} value={v._id}>
                {v.workspaceName}
              </option>
            ))}
          </Select>
        </>
      )}
    </SingleQueryResults>
  );
};
